import { useContext, useState } from "react";
import { ProjectInfoContext } from "../../../../context/ProjectInfoContext";
import Style from "../SpecialInputFirstInputForm.module.css";

const SpecialInputProjectPartnersExpenses = ({ addNewPartnerProp }) => {
  const [otherPartnerName, setOtherPartnerName] = useState("");
  const [otherPartner, setOtherPartnerPercentage] = useState("");
  const { projectinfosId } = useContext(ProjectInfoContext);

  const addNewPartner = () => {
    if (otherPartnerName === "" || otherPartner === "") {
      alert("Niste unijeli sve podatke...");
      return;
    }

    const newPartner = {
      projectinfosId: projectinfosId,
      name: otherPartnerName,
      budget: otherPartner,
    };
    if (addNewPartnerProp(newPartner) === -1) return;
    setOtherPartnerName("");
    setOtherPartnerPercentage("");
  };

  const handlePercentageChange = (e) => {
    const value = e.target.value;

    setOtherPartnerPercentage(value);
  };

  return (
    <div className={Style.SpecialInputMemberProjectsProject}>
      <input
        value={otherPartnerName}
        className={Style.SpecialInputTextInput}
        placeholder="naziv..."
        onChange={(e) => setOtherPartnerName(e.target.value)}
      />
      <input
        value={otherPartner}
        className={Style.SpecialInputNumberInput}
        placeholder="trošak..."
        type="number"
        onChange={handlePercentageChange}
      />
      EUR
      <button className={Style.SpecialInputAddProject} onClick={addNewPartner}>
        DODAJ
      </button>
    </div>
  );
};

export default SpecialInputProjectPartnersExpenses;
